import { render, staticRenderFns } from "./FeedBasic.vue?vue&type=template&id=5fd94b18"
import script from "./FeedBasic.vue?vue&type=script&lang=js"
export * from "./FeedBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports